import React from 'react';
import ArgonBox from 'components/ArgonBox';
import ArgonTypography from 'components/ArgonTypography';
import { Card, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { grey } from '@mui/material/colors';

// Fake data for discount schedules - replace with actual data fetching
const fakeDiscountSchedules = [
  { id: 1, name: 'Volume Discount', type: 'Percentage', amount: '10%', condition: 'Quantity >= 10' },
  { id: 2, name: 'Loyalty Discount', type: 'Fixed Amount', amount: '$50', condition: 'Customer since > 1 year' },
];

function OfferingDiscounts({ product }) {
  return (
    <Card>
      <ArgonBox p={3}>
        <TableContainer component={Paper}>
          <Table aria-label="discount schedules table">
            <TableHead sx={{ display: 'contents' }}>
              <TableRow>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '14px', color: grey[700] }}>Name</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '14px', color: grey[700] }}>Type</TableCell>
                <TableCell sx={{ fontWeight: 'bold', fontSize: '14px', color: grey[700] }}>Amount</TableCell>
                <TableCell align="center" sx={{ fontWeight: 'bold', fontSize: '14px', color: grey[700] }}>
                  Condition
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {fakeDiscountSchedules.map((discount) => (
                <TableRow key={discount.id}>
                  <TableCell>{discount.name}</TableCell>
                  <TableCell>{discount.type}</TableCell>
                  <TableCell>{discount.amount}</TableCell>
                  <TableCell align="center">{discount.condition}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </ArgonBox>
    </Card>
  );
}

export default OfferingDiscounts;
